import Axios from 'axios'
import store from '../store'
import utils from '@/utils/utils.js'

export default {
  getAuthUrlBase() {
    const authUrlBase = process.env.VUE_APP_URL_SERVER_BASE_AUTH
    const tenantId = store.getters['Client/clientId']

    return `${authUrlBase}api/v1/${tenantId}`
  },
  searchPaginated(page, size) {
    const config = utils.generateQueryString({ page, size }, false)
    return Axios.get(`${this.getAuthUrlBase()}/accounts/search`, config, {
      ignoreGlobalCatch: true,
    })
  },
  searchPaginatedByTerm(page, size, term) {
    const config = utils.generateQueryString({ page, size, search: term }, false)
    return Axios.get(`${this.getAuthUrlBase()}/accounts/search`, config, {
      ignoreGlobalCatch: true,
    })
  },
  getAccount(userId) {
    return Axios.get(`${this.getAuthUrlBase()}/accounts/${userId}`, {
      ignoreGlobalCatch: true,
    })
  },
  editAccount(payload) {
    return Axios.put(`${this.getAuthUrlBase()}/accounts/${payload.id}`, payload, {
      ignoreGlobalCatch: true,
    })
  },
  resetPassword(userId, passwordPayload) {
    return Axios.post(`${this.getAuthUrlBase()}/accounts/${userId}/reset-password`, passwordPayload, {
      ignoreGlobalCatch: true,
    })
  },
  removeAccount(userId) {
    return Axios.delete(`${this.getAuthUrlBase()}/accounts/${userId}`, {
      ignoreGlobalCatch: true,
    })
  },
  saveAccount(payload) {
    return Axios.post(`${this.getAuthUrlBase()}/accounts/register`, payload, {
      ignoreGlobalCatch: true,
    })
  },
  getAccountsTemplateFile() {
    let config = { responseType: 'arraybuffer', ignoreGlobalCatch: true }
    return Axios.get(`${this.getAuthUrlBase()}/accounts/export/template`, config)
  },
  getAccountsFile(params) {
    let config = { responseType: 'arraybuffer', ignoreGlobalCatch: true }
    return Axios.get(`${this.getAuthUrlBase()}/accounts/export?exportId=${params.exportId}`, config)
  },
  getAccountsFileErrors(fileId) {
    let headers = { responseType: 'arraybuffer', ignoreGlobalCatch: true }
    return Axios.get(`${this.getAuthUrlBase()}/accounts/import/${fileId}`, headers)
  },
  importAccountsFile(file) {
    let fileForm = new FormData()
    fileForm.append('file', file)
    return Axios.post(`${this.getAuthUrlBase()}/accounts/import`, fileForm, {
      ignoreGlobalCatch: true,
    })
  }
}
